<template>
  <v-form ref="form" @submit.prevent="onSubmit" v-model="isFormValid" lazy-validation :disabled="isFormDisabled">
    <div v-if="getIsMultiPageImport()" class="scrollable">
      <v-card-text v-for="(id, idx) in pageIds" :key="id">
        <div class="pb-4" v-if="pageIds.length > 1 && chipTexts[id]">
          <v-chip>{{ chipTexts[id] }}</v-chip>
        </div>
        <label class="grey--text text--darken-1" for="title-field">Page Title</label>
        <v-text-field class="mt-2" outlined dense :rules="[isRequired]" v-model="titles[id]"></v-text-field>
        <label class="grey--text text--darken-1">Page Sponsor Image</label>
        <upload-image
          :value="sponsors[id].image.url"
          height="50"
          width="320"
          :fileUrl="sponsors[id].image.url"
          @input="sponsors[id].image.url = $event"
          :client-id="program.clientId"
          key="2"
          class="mb-5 mt-2"
        />
        <label class="grey--text text--darken-1" for="alt-text-field">Alt Text</label>
        <v-text-field class="mb-5 mt-2" outlined hide-details dense v-model="sponsors[id].image.alt"></v-text-field>
        <label class="grey--text text--darken-1" for="image-link-field">Image URL Redirect Link</label>
        <v-text-field class="mb-5 mt-2" hide-details outlined dense v-model="sponsors[id].image.link"></v-text-field>
        <v-divider v-if="idx < pageIds.length - 1" class="mt-10"></v-divider>
      </v-card-text>
    </div>
    <v-card-text class="scrollable" v-else>
      <label class="grey--text text--darken-1" for="title-field">Page Title</label>
      <v-text-field id="title-field" class="mt-2" outlined dense :rules="[isRequired]" v-model="title"></v-text-field>
      <label class="grey--text text--darken-1">Page Sponsor Image</label>
      <upload-image
        :value="sponsor.image.url"
        height="50"
        width="320"
        :fileUrl="sponsor.image.url"
        @input="sponsor.image.url = $event"
        :client-id="program.clientId"
        key="2"
        class="mb-5 mt-2"
      />
      <label class="grey--text text--darken-1" for="alt-text-field">Alt Text</label>
      <v-text-field
        id="alt-text-field"
        class="mb-5 mt-2"
        outlined
        hide-details
        dense
        v-model="sponsor.image.alt"
      ></v-text-field>
      <label class="grey--text text--darken-1" for="image-link-field">Image URL Redirect Link</label>
      <v-text-field
        id="image-link-field"
        class="mb-5 mt-2"
        hide-details
        outlined
        dense
        v-model="sponsor.image.link"
      ></v-text-field>
    </v-card-text>
    <v-card-actions class="pa-4 elevation-5">
      <v-btn depressed color="grey lighten-4" class="text-capitalize" @click="goBack">Back</v-btn>
      <v-btn color="primary" type="submit" depressed class="text-capitalize" :disabled="!isFormValid"> Continue </v-btn>
      <v-spacer></v-spacer>
      <v-btn depressed color="grey lighten-4" class="text-capitalize" @click="reset">Clear</v-btn>
      <v-btn text class="text-capitalize elevation-0" @click="close">Cancel</v-btn>
    </v-card-actions>
  </v-form>
</template>
<script lang="ts">
  import { VForm } from '@/types';
  import Vue, { VueConstructor } from 'vue';
  import UploadImage from '@/components/Ui/UploadImage.vue';
  import { mapActions, mapGetters } from 'vuex';
  import { eventBus } from '../../main';
  import { CreatePagesPayload, Page, PageContent } from '@/store/builder/types';

  interface Block {
    config: object;
    data: object;
    id: number;
    type: string;
  }

  interface Injections {
    toggleLoading: () => void;
    getPageContent: (id?: string) => PageContent;
    getTemplateId: () => number;
    getIsMultiPageImport: () => boolean;
    goBack: () => void;
    close: () => void;
  }
  export default (Vue as VueConstructor<Vue & Injections>).extend({
    name: 'PageDetails',
    components: { UploadImage },
    inject: ['toggleLoading', 'getPageContent', 'getTemplateId', 'goBack', 'close', 'getIsMultiPageImport'],
    data() {
      return {
        isFormValid: true,
        isFormDisabled: false,
        title: '',
        sponsor: {
          image: {
            url: '',
            alt: '',
            link: '',
          },
        },
        titles: {} as { [id: string]: string },
        chipTexts: {} as { [id: string]: string },
        sponsors: {} as {
          [id: string]: {
            image: {
              url: string;
              alt: string;
              link: string;
            };
          };
        },
        pageIds: [] as string[],
      };
    },
    computed: {
      ...mapGetters('programs', { program: 'getProgram' }),
      // pageIds(): string[] {
      //   return Object.keys(this.titles);
      // },
    },
    methods: {
      ...mapActions('builder', { savePage: 'savePage', createPages: 'createPages' }),
      ...mapActions('ui', { showToast: 'showToast' }),
      isRequired(value: string | number): boolean | string {
        return (
          (typeof value === 'string' && !!value.trim().length) ||
          (typeof value === 'number' && value > 0) ||
          'Field is required'
        );
      },
      // sortPageIds() {
      //   const ids = Object.keys(this.titles);
      //   const titleObjs = ids.map((id) => ({
      //     id,
      //     title: this.titles[id],
      //   }));

      //   this.pageIds = sortBy(titleObjs, ['title', 'id']).map((obj) => obj.id);
      // },
      setTitle(title: string, id?: string) {
        if (id) {
          if (!(id in this.titles)) {
            this.titles = { ...this.titles, [id]: title };
            this.sponsors = {
              ...this.sponsors,
              [id]: {
                image: {
                  alt: '',
                  link: '',
                  url: '',
                },
              },
            };
            this.pageIds.push(id);
          }
          this.titles[id] = title;
          return;
        }

        if (!this.title) {
          this.title = title;
        }
      },
      getTitle(id?: string) {
        if (id) {
          return this.titles[id];
        }

        return this.title;
      },
      setChipText(text: string, id: string) {
        this.chipTexts = { ...this.chipTexts, [id]: text };
      },
      clear() {
        this.titles = {};
        this.sponsors = {};
        this.chipTexts = {};
        this.pageIds = [];
      },
      async onSubmit() {
        this.toggleLoading();
        this.isFormDisabled = true;

        try {
          if (this.getIsMultiPageImport()) {
            //dd
            var payload: CreatePagesPayload = {
              programId: this.program.id,
              pages: [],
            };
            this.pageIds.forEach((id) => {
              payload.pages.push({
                title: this.titles[id],
                sponsor: this.sponsors[id],
                content: this.getPageContent(id),
                templateId: null,
              });
            });

            var pages: Page[] = await this.createPages(payload);

            eventBus.$emit('changePage', pages[0].id);
          } else {
            const { title, sponsor, program } = this;
            const templateId = this.getTemplateId();
            const content = this.getPageContent();

            const response = await this.savePage({
              programId: program.id,
              page: {
                title,
                content,
                templateId,
                sponsor,
              },
            });
            eventBus.$emit('changePage', response.id);
          }

          this.close();
        } catch (error) {
          const msg = error?.response?.data || 'Could not create page';
          this.showToast(msg);
        } finally {
          this.toggleLoading();
          this.isFormDisabled = false;
        }
      },
      reset() {
        (this.$refs.form as VForm).reset();
      },
    },
  });
</script>
